<template>
  <div class="size-types">
    <label v-for="size in sizes" :key="size.id" class="size-types__option">
      <input type="checkbox" :value="size.id" :checked="modelValue.includes(size.id)" @change="toggle(size.id)" />
      {{ size.title }}
    </label>
  </div>
</template>

<script>
export default {
  name: "SizeTypeCheckboxes",
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      sizes: [],
    };
  },
  methods: {
    toggle(id) {
      const selected = this.modelValue.includes(id)
        ? this.modelValue.filter((sizeId) => sizeId !== id)
        : [...this.modelValue, id];
      this.$emit("update:modelValue", selected);
    },
  },
  async mounted() {
    try {
      const res = await this.$api.get(`${process.env.VUE_APP_SHARED_API}api/size-types`);
      this.sizes = res.data.data;
    } catch (_) { }
  },
};
</script>

<style scoped>
.size-types {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.size-types__option {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}
</style>
